export type ActivationRollupStatus = 'active' | 'invited' | 'inactive';

export const activationTimestamp = (record: Record<string, any>): number => {
  const value = record.updated_at || record.activated_at || record.consumed_at || record.created_at || 0;
  const stamp = new Date(value).getTime();
  return Number.isFinite(stamp) ? stamp : 0;
};

export const isActiveActivation = (record: Record<string, any>): boolean => {
  const activeSignal = record.activated === true
    || String(record.status || '').toLowerCase() === 'active'
    || !!record.activated_at
    || !!record.consumed_at;
  return activeSignal
    && record.deactivated !== true
    && !record.deactivated_at
    && !record.revoked_at
    && String(record.status || '').toLowerCase() !== 'revoked';
};

export const isPendingActivation = (record: Record<string, any>): boolean =>
  !isActiveActivation(record)
  && !!(record.activation_code || record.video_activation_code)
  && record.deactivated !== true
  && !record.deactivated_at
  && !record.revoked_at
  && String(record.status || '').toLowerCase() !== 'revoked';

export function summarizeActivations(records: Record<string, any>[]) {
  const sorted = [...records].sort((a, b) => activationTimestamp(b) - activationTimestamp(a));
  const activeRecords = sorted.filter(isActiveActivation);
  const pendingRecords = sorted.filter(isPendingActivation);
  const revokedRecords = sorted.filter((record) =>
    record.deactivated === true || !!record.deactivated_at || !!record.revoked_at || String(record.status || '').toLowerCase() === 'revoked');
  const primary = activeRecords[0] || pendingRecords[0] || sorted[0] || {};
  const status: ActivationRollupStatus = activeRecords.length ? 'active' : pendingRecords.length ? 'invited' : 'inactive';
  const platforms = Array.from(new Set(activeRecords
    .map((record) => String(record.platform || '').trim().toLowerCase())
    .filter(Boolean)));
  return {
    status,
    active: status === 'active',
    totalCount: sorted.length,
    activeCount: activeRecords.length,
    pendingCount: pendingRecords.length,
    revokedCount: revokedRecords.length,
    primary,
    platforms,
    activatedAt: activeRecords[0]?.activated_at || activeRecords[0]?.consumed_at || null,
  };
}
